// extracted by mini-css-extract-plugin
export default {"host":"EstablishmentCard_host__OeQrV","header":"EstablishmentCard_header__NvxzL","name":"EstablishmentCard_name__Lpii8"};